// @flow
import React from 'react';
import { Helmet } from 'react-helmet';
import moment from 'moment';
import 'moment/locale/ko';
import './OrderTaxTemplate.scss';

type Props = {
  order: any,
  user: any,
  logged: boolean,
};

const OrderTaxTemplate = (props: Props) => (
  <div className="OrderTaxTemplate">
    <Helmet>
      <title>{`캐시바이-세금계산서-${moment().format('YYYY-MM-DD-HH:mm:ss')}`}</title>
    </Helmet>
    <div className="main">
      <img
        src={props.order.meta.taxFile}
        className="tax-image"
        alt="세금계산서"
      />
    </div>
  </div>
);

export default OrderTaxTemplate;



// WEBPACK FOOTER //
// ./src/components/order/OrderTaxTemplate/OrderTaxTemplate.js